// Autogenerated file
export const trackerRelationTypesEnum = {
    Default: "Default",
    Car: "Car",
    Mobile: "Mobile",
    Trailer: "Trailer",
};
export const trackerRelationTypes = [
    { label: "Без связи", value: "Default" },
    { label: "Машина", value: "Car" },
    { label: "Мобильный телефон", value: "Mobile" },
    { label: "Прицеп", value: "Trailer" },
];
